import React, { useState } from 'react';
import { Smartphone, Scan, ZoomIn, ZoomOut, RotateCw, Maximize2, Check, AlertCircle } from 'lucide-react';
export const ARCompanionMode = () => {
  const [scanComplete, setScanComplete] = useState(false);
  const [scanning, setScanning] = useState(false);
  const [companionPlaced, setCompanionPlaced] = useState(false);
  const [companionSize, setCompanionSize] = useState(50);
  const handleScan = () => {
    setScanning(true);
    setTimeout(() => {
      setScanning(false);
      setScanComplete(true);
    }, 3000);
  };
  const handlePlaceCompanion = () => {
    setCompanionPlaced(true);
  };
  return <div className="space-y-6" data-id="element-22480">
      <div data-id="element-22481">
        <h3 className="text-lg font-medium mb-2" data-id="element-22482">AR Companion Mode</h3>
        <p className="text-sm text-gray-400 mb-4" data-id="element-22483">
          Place your AI companion in your real environment using augmented
          reality
        </p>
        <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden" data-id="element-22484">
          <div className="aspect-video relative" data-id="element-22485">
            {companionPlaced ? <img src="https://images.unsplash.com/photo-1600566752355-35792bedcfea?q=80&w=2070&auto=format&fit=crop" alt="AR View with companion" className="w-full h-full object-cover" data-id="element-22486" /> : scanComplete ? <img src="https://images.unsplash.com/photo-1600566752229-250ed79470f8?q=80&w=2070&auto=format&fit=crop" alt="Scanned room" className="w-full h-full object-cover" data-id="element-22487" /> : <div className="w-full h-full bg-gray-800 flex flex-col items-center justify-center" data-id="element-22488">
                {scanning ? <>
                    <Scan size={48} className="text-pink-400 animate-pulse mb-4" data-id="element-22489" />
                    <p className="text-sm text-gray-300" data-id="element-22490">
                      Scanning your environment...
                    </p>
                    <p className="text-xs text-gray-400 mt-2" data-id="element-22491">
                      Move your phone around slowly
                    </p>
                    <div className="w-48 h-2 bg-gray-700 rounded-full mt-4 overflow-hidden" data-id="element-22492">
                      <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 w-2/3 rounded-full animate-pulse" data-id="element-22493"></div>
                    </div>
                  </> : <>
                    <Smartphone size={48} className="text-gray-400 mb-4" data-id="element-22494" />
                    <p className="text-sm text-gray-300" data-id="element-22495">
                      Point your camera at an open area
                    </p>
                    <p className="text-xs text-gray-400 mt-2" data-id="element-22496">
                      Make sure you have good lighting
                    </p>
                  </>}
              </div>}
            {scanComplete && !companionPlaced && <div className="absolute inset-0 flex items-center justify-center" data-id="element-22497">
                <div className="w-48 h-48 border-2 border-dashed border-pink-500/70 rounded-full animate-pulse flex items-center justify-center" data-id="element-22498">
                  <button className="px-4 py-2 bg-pink-600/80 backdrop-blur-sm rounded-lg text-white text-sm font-medium" onClick={handlePlaceCompanion} data-id="element-22499">
                    Place Sophia Here
                  </button>
                </div>
              </div>}
            {companionPlaced && <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2 px-4 py-2 bg-black/60 backdrop-blur-sm rounded-full" data-id="element-22500">
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800" data-id="element-22501">
                  <ZoomIn size={16} className="text-gray-300" data-id="element-22502" />
                </button>
                <input type="range" min="20" max="100" value={companionSize} onChange={e => setCompanionSize(parseInt(e.target.value))} className="w-24 accent-pink-500" data-id="element-22503" />
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800" data-id="element-22504">
                  <ZoomOut size={16} className="text-gray-300" data-id="element-22505" />
                </button>
                <div className="w-px h-6 bg-gray-700 mx-1" data-id="element-22506"></div>
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800" data-id="element-22507">
                  <RotateCw size={16} className="text-gray-300" data-id="element-22508" />
                </button>
              </div>}
          </div>
          <div className="p-3 border-t border-gray-800 flex items-center justify-between" data-id="element-22509">
            <div className="flex items-center gap-2" data-id="element-22510">
              <div className={`w-3 h-3 rounded-full ${scanComplete ? 'bg-green-500' : 'bg-gray-500'}`} data-id="element-22511"></div>
              <span className="text-xs text-gray-400" data-id="element-22512">
                {scanComplete ? 'Environment mapped' : 'Ready to scan'}
              </span>
            </div>
            {!scanComplete ? <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-xs font-medium flex items-center gap-1" onClick={handleScan} disabled={scanning} data-id="element-22513">
                {scanning ? <>
                    <Scan size={12} className="animate-pulse" data-id="element-22514" />
                    <span data-id="element-22515">Scanning...</span>
                  </> : <>
                    <Scan size={12} data-id="element-22516" />
                    <span data-id="element-22517">Scan Room</span>
                  </>}
              </button> : companionPlaced ? <button className="px-3 py-1.5 bg-gradient-to-r from-green-600 to-emerald-600 rounded-lg text-white text-xs font-medium flex items-center gap-1" data-id="element-22518">
                <Check size={12} data-id="element-22519" />
                <span data-id="element-22520">Companion Placed</span>
              </button> : <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-xs font-medium flex items-center gap-1" data-id="element-22521">
                <Maximize2 size={12} data-id="element-22522" />
                <span data-id="element-22523">Place Companion</span>
              </button>}
          </div>
        </div>
      </div>
      <div className="space-y-3" data-id="element-22524">
        <h3 className="text-lg font-medium" data-id="element-22525">AR Companion Settings</h3>
        <div className="grid grid-cols-2 gap-3" data-id="element-22526">
          <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22527">
            <h4 className="font-medium mb-2" data-id="element-22528">Companion Size</h4>
            <div className="flex items-center gap-2" data-id="element-22529">
              <ZoomOut size={14} className="text-gray-400" data-id="element-22530" />
              <input type="range" min="20" max="100" value={companionSize} onChange={e => setCompanionSize(parseInt(e.target.value))} className="flex-1 accent-pink-500" data-id="element-22531" />
              <ZoomIn size={14} className="text-gray-400" data-id="element-22532" />
            </div>
            <div className="flex items-center justify-between mt-1" data-id="element-22533">
              <span className="text-xs text-gray-400" data-id="element-22534">Petite</span>
              <span className="text-xs text-gray-400" data-id="element-22535">{companionSize}%</span>
              <span className="text-xs text-gray-400" data-id="element-22536">Life-size</span>
            </div>
          </div>
          <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22537">
            <h4 className="font-medium mb-2" data-id="element-22538">Outfit Selection</h4>
            <div className="grid grid-cols-4 gap-1" data-id="element-22539">
              <div className="aspect-square rounded bg-pink-900/30 border border-pink-800/50" data-id="element-22540"></div>
              <div className="aspect-square rounded bg-purple-900/30 border border-purple-800/50" data-id="element-22541"></div>
              <div className="aspect-square rounded bg-blue-900/30 border border-blue-800/50" data-id="element-22542"></div>
              <div className="aspect-square rounded bg-gray-700 border border-gray-600 flex items-center justify-center text-xs text-gray-400" data-id="element-22543">
                +
              </div>
            </div>
            <div className="text-xs text-gray-400 mt-2 text-center" data-id="element-22544">
              4 outfits available
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3" data-id="element-22545">
          <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22546">
            <div className="flex items-center justify-between mb-2" data-id="element-22547">
              <h4 className="font-medium" data-id="element-22548">Interaction Mode</h4>
              <div className="w-8 h-4 bg-pink-900/30 rounded-full relative" data-id="element-22549">
                <div className="absolute inset-0 m-0.5 bg-pink-500 rounded-full left-1/2 right-0" data-id="element-22550"></div>
              </div>
            </div>
            <p className="text-xs text-gray-400" data-id="element-22551">
              Allow physical interactions with your companion in AR
            </p>
          </div>
          <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22552">
            <div className="flex items-center justify-between mb-2" data-id="element-22553">
              <h4 className="font-medium" data-id="element-22554">Voice Commands</h4>
              <div className="w-8 h-4 bg-pink-900/30 rounded-full relative" data-id="element-22555">
                <div className="absolute inset-0 m-0.5 bg-pink-500 rounded-full left-1/2 right-0" data-id="element-22556"></div>
              </div>
            </div>
            <p className="text-xs text-gray-400" data-id="element-22557">
              Control your companion with voice in AR mode
            </p>
          </div>
        </div>
        <div className="bg-gray-800 rounded-lg p-3 border border-gray-700" data-id="element-22558">
          <div className="flex items-center gap-2 mb-2" data-id="element-22559">
            <AlertCircle size={16} className="text-pink-400" data-id="element-22560" />
            <h4 className="font-medium" data-id="element-22561">AR Best Practices</h4>
          </div>
          <ul className="text-xs text-gray-400 space-y-1 ml-6 list-disc" data-id="element-22562">
            <li data-id="element-22563">Ensure good lighting for optimal tracking</li>
            <li data-id="element-22564">Scan your entire space before placing your companion</li>
            <li data-id="element-22565">Clear any obstacles from your interaction area</li>
            <li data-id="element-22566">For best results, use a device with LiDAR scanning</li>
          </ul>
        </div>
      </div>
    </div>;
};